module.exports = __webpack_public_path__ + "img/jbt9162_24_1999.prt.866a0dd9.jpg";